var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-input",
    {
      attrs: { placeholder: _vm.placeholder },
      model: {
        value: _vm.model,
        callback: function ($$v) {
          _vm.model = $$v
        },
        expression: "model",
      },
    },
    [
      _c("template", { slot: "append" }, [
        _c("span", [_vm._v(_vm._s(_vm.commasValue))]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.currency))]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }